import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker as MuiDateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { useEffect, useState } from "react";
import enLocale from "dayjs/locale/en-au";
import { TextField } from "@mui/material";

enLocale.formats = {
  ...enLocale.formats,
  L: "",
};

const DateTimePicker = ({
  name,
  label,
  value,
  onChange,
  variant,
  inputFormat = "DD/MM/YYYY HH:mm A",
}) => {
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    setSelectedDate(dayjs(value));
  }, [value]);

  const onChangeDate = (date) => {
    setSelectedDate(date);
    const e = {
      target: {
        name: name,
        value: date,
      },
    };
    onChange(e);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"en-au"}>
      <MuiDateTimePicker
        label={label}
        value={selectedDate}
        onChange={onChangeDate}
        renderInput={(props) => <TextField {...props} variant={variant} />}
        inputFormat={inputFormat}
      />
    </LocalizationProvider>
  );
};

export default DateTimePicker;
